import PropTypes from 'prop-types';
import { Backdrop, Typography, Paper, Fade, Modal } from '@mui/material';
import { SecondaryButton } from '../Button';

const AlertModal = ({
  isOpen,
  handleClose,
  title,
  icon,
  message,
  closeMessage = 'Close',
  additionalButton,
  closeButtonType: CloseButton,
}) => {
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className="modal-backdrop modal-backdrop--light"
      open={isOpen}
      disableAutoFocus
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
    >
      <Fade in={isOpen}>
        <Paper elevation={1} className="modal modal--large modal--tc">
          <div className="modal__icon">{icon}</div>
          <div className="modal__title mb-0">
            <Typography
              variant="p"
              style={{
                textAlign: 'center',
                color: '#242467',
                fontWeight: 'bold',
                fontSize: '20px',
              }}
            >
              {title}
            </Typography>
          </div>

          <Typography variant="p">{message}</Typography>
          <div className="modal__buttons mt-30">
            {additionalButton}
            <CloseButton
              className="button button--error"
              size="small"
              style={{ width: '100%' }}
              onClick={handleClose}
            >
              {closeMessage}
            </CloseButton>
          </div>
        </Paper>
      </Fade>
    </Modal>
  );
};

AlertModal.propTypes = {
  isOpen: PropTypes.bool,
  handleClose: PropTypes.func,
  title: PropTypes.string,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  icon: PropTypes.node,
  closeMessage: PropTypes.string,
  additionalButton: PropTypes.node,
  closeButtonType: PropTypes.object,
};

AlertModal.defaultProps = {
  closeMessage: 'Close',
  additionalButton: <></>,
  closeButtonType: SecondaryButton,
};

export default AlertModal;
